import './SpacingInput.css'

import React, { useCallback } from 'react'

import { RadiusBotLeft16, RadiusBotRight16, RadiusTopLeft16, RadiusTopRight16 } from '@makyoapp/makyo-icon/icon'

import { SpacingInputUnit } from '@/shared/builder'

import { SpaceFieldWithUnit } from './SpaceFieldWithUnit'

export type RadiusInputValue = Record<
  RadiusInputPosition,
  {
    value: number
    unit: SpacingInputUnit
  }
>

export enum RadiusInputPosition {
  StartStart = 'start-start',
  StartEnd = 'start-end',
  EndStart = 'end-start',
  EndEnd = 'end-end',
}

export interface RadiusInputProps {
  id?: string
  values: RadiusInputValue
  onChange: (nextValues: RadiusInputValue) => void
}
export function RadiusInput({
  id,
  values = {
    'start-start': { value: 0, unit: SpacingInputUnit.Pixel },
    'start-end': { value: 0, unit: SpacingInputUnit.Pixel },
    'end-start': { value: 0, unit: SpacingInputUnit.Pixel },
    'end-end': { value: 0, unit: SpacingInputUnit.Pixel },
  },
  onChange,
}: RadiusInputProps) {
  const handleChange = useCallback(
    (value: number, unit: SpacingInputUnit, position?: RadiusInputPosition) => {
      const copy = { ...values }
      if (position) {
        copy[position] = {
          value,
          unit,
        }
      }
      onChange(copy)
    },
    [onChange, values]
  )

  return (
    <div id={id} className='spi'>
      <SpaceFieldWithUnit
        id={`${id}-start-start`}
        icon={<RadiusTopLeft16 />}
        value={values[RadiusInputPosition.StartStart]}
        position={RadiusInputPosition.StartStart}
        onChange={handleChange}
      />
      <SpaceFieldWithUnit
        id={`${id}-start-end`}
        icon={<RadiusTopRight16 />}
        value={values[RadiusInputPosition.StartEnd]}
        position={RadiusInputPosition.StartEnd}
        onChange={handleChange}
      />
      <SpaceFieldWithUnit
        id={`${id}-end-start`}
        icon={<RadiusBotLeft16 />}
        value={values[RadiusInputPosition.EndStart]}
        position={RadiusInputPosition.EndStart}
        onChange={handleChange}
      />
      <SpaceFieldWithUnit
        id={`${id}-end-end`}
        icon={<RadiusBotRight16 />}
        value={values[RadiusInputPosition.EndEnd]}
        position={RadiusInputPosition.EndEnd}
        onChange={handleChange}
      />
    </div>
  )
}
